
import React, {useState, useEffect, useContext} from 'react';
import { Avatar, Grid, Paper, FormControlLabel, Switch, Typography, Button, Box } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useFileUpload } from 'core/hooks/useFileUpload';
import { useSnackbar } from 'notistack';
import { useForm, Controller } from "react-hook-form";
// import { uploadProfilePhoto } from 'core/services/profile';
import FileUploads from 'components/file-uploads';
import { getUploadedDocuments, sendEmailVerificationLink } from 'core/services/profile';
import { AuthContext } from 'core/context';
import { uploadFiles } from '../../../services/commonServices';

const AccountLogo = ({accountDetails}) => {

  const defaultFormValues = {image: ''};
  const { active = 'N', name, email = '', mobile = '', emailVerified } = accountDetails;
  const [profileImage, setProfileImage] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const { handleSubmit, control } = useForm({
    defaultValues: {...defaultFormValues}
  });
  const [fileInput, setFileInput] = useState();
  const [UploadFile, setUploadFile] = useState(false);
  const { inmateId, data: { pgName } } = useContext(AuthContext);

  const [uploadPhoto] = useFileUpload({
		onStarting: (file) => {
      setFileInput(file);
			var reader = new FileReader();
			reader.readAsDataURL(file)
			reader.onloadend = () => setProfileImage(reader.result)
      // onSubmit({image: file});
		}
  });

  function onSubmit() {
    if(!fileInput)  return enqueueSnackbar("Select a image to upload", {variant: 'error'});
 const postData = {
      file: fileInput,
      fileName: fileInput.name,
      documentType: 'PHOTO'
    };
    uploadFiles({...postData}).then(({response, error}) => {
      if(error){
        enqueueSnackbar((error?.message || error), {variant: 'error'});
      }else{
        enqueueSnackbar((response?.message || 'File uploaded sucessfully'), {variant: 'success'});
      }
    });
  }

  function loadUploadedDocuments(){
    getUploadedDocuments().then(({response, error}) => {
      if(error){
        enqueueSnackbar((error?.message), {variant: 'success'});
      }else{
        const photoUploaded = response?.photoUploaded ? `/rest/user/${inmateId}/document/PHOTO` : null
        setProfileImage(photoUploaded);
      }
    })
  }

  function onSendEmailVerificationLinkBtnClick() {
    sendEmailVerificationLink().then(({error}) => {
      if(error){
        enqueueSnackbar((error?.message), {variant: 'error'});
      }else{
        enqueueSnackbar("Email verification link has been sent to your email address", {variant: 'success'});
      }
    })
  }

  useEffect(() => {
    loadUploadedDocuments();
  }, []);


  function onFileUploadSuccess() {
    setProfileImage(null);
    loadUploadedDocuments();
  }

  const modalClosed = () => {
    setUploadFile(false);
  }

  return (
    <Paper  sx={{py: 6, px: 3, boxShadow: 'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px'}}>
      <Grid
        container
        direction="row" 
        justifyContent="center"
        alignItems="center"
      >
        { profileImage ? (
          <Avatar variant="square" src={profileImage} sx={{ width: 200, height: 200 }} /> 
        ) : <Avatar variant="square" sx={{ width: 200, height: 200 }} >
          <AccountCircleIcon sx={{ fontSize: 150 }} />
        </Avatar>}
        {pgName ? null : (
        <Grid item xs={12} sx={{textAlign: 'center'}}>
          {/* <Button type="button" variant="contained" color="success" size="small" sx={{m: 1}} onClick={() => setUploadFile(true)}>
            Upload
          </Button> */}
          <FileUploads onFileUploadSuccess={onFileUploadSuccess} showUploads={UploadFile} modalTitle="Upload Profile Photo" modalClosed={modalClosed} type={'PHOTO'} accept='.jpg, .jpeg' />
        </Grid>)}
      </Grid>
      <Grid container direction="row" justifyContent="center" alignItems="center" sx={{my: 1, p: 1}}>
        <Grid item xs={12} sm={12} md={12} lg={12} sx={{textAlign: "center"}} >
          <Box component="form" noValidate onSubmit={handleSubmit(onSubmit)} sx={{ mt: 1 }}>
            <Controller
              control={control}
              name="image"
              id="image"
              render={({field}) => (
                <>
                  <input
                    id="profile-photo-input"
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={(event) => {
                      field.onChange(event);
                      uploadPhoto(event);
                    }}
                  />
                  <Button
                    component="label"
                    htmlFor="profile-photo-input"
                    variant="outlined"
                    color="secondary"
                    startIcon={<PhotoCameraIcon />}
                    sx={{m: 1, px: 2.5, textTransform: 'inherit'}}
                  >
                    Choose photo
                  </Button>
                </>
              )}
            />
            {/* {fileInput?.name && (
              <Typography variant="body2" color="text.secondary" sx={{mt: 0.5, mb: 1}}>
                {fileInput.name}
              </Typography>
            )} */}
            <Button type="submit" variant="contained" color="success"  size="medium" startIcon={<CloudUploadIcon />} sx={{m: 1, textTransform: 'inherit'}}>
              Upload
            </Button>
          </Box>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Typography variant="h6" component="p" sx={{mt: 3}}>
            {name}
          </Typography>
        </Grid>
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Typography  component="p">
            {mobile}
          </Typography>
        </Grid>
        <Grid container direction="column" justifyContent="center" alignItems="center">
          <Typography variant="caption"  sx={{mt: 1}}>
              {email}
          </Typography>
          {!emailVerified && <Box variant="caption"  sx={{mt: 1}}>
            <Button variant="text" onClick={onSendEmailVerificationLinkBtnClick}>Verify Email</Button>
         </Box>}
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        sx={{mt: 4}}
      >
        <FormControlLabel disabled control={<Switch checked={active === 'Y'} color="success" />} label="Active" labelPlacement="start" />
      </Grid>
    </Paper>
  );
}
 
export default AccountLogo;
